// store.js
import Vue from 'vue';
import Vuex from 'vuex';
import VueCookies from 'vue-cookies-reactive';

import modules from './modules'

import ItemsApi from "@/services/items-api";
import CartApi from "@/services/cart-api";



Vue.use(Vuex);
Vue.use(VueCookies);

// Define constants
const CART_ID_COOKIE_NAME = 'uscid';
const MAIN_SECTION_COOKIE_NAME = 'msid';
const COMPARATOR_ITEMS_COOKIE_NAME = 'cil';
const GIFT_CODE = 'gwc';

const store =  new Vuex.Store({

  modules,

  // Enable strict mode in development to get a warning
  // when mutating state outside of a mutation.
  // https://vuex.vuejs.org/guide/strict.html
  strict: process.env.NODE_ENV !== 'production',

  state: {

    //CART
    cart: null,
    isLoadingCart: false,

    //MENU
    menuItems: [],
    mainSectionId: null,

    //COMPARATOR
    comparatorItems: [] ,

    //GIFTCODE
    giftCode: null,
  },

  mutations: {

    ////////////////////////
    // GIFT CODE MUTATIONS

    setGiftCode(state, giftCode) {
      if (!giftCode) {
        clearCookie(GIFT_CODE)
      }
      writeCookie(GIFT_CODE, giftCode);
      state.giftCode = giftCode;
    },


    //////////////
    // MENU ITEMS MUTATIONS

    setMenuItems(state, items) {
      state.menuItems = items;
    },

    setMainSectionId(state, newId) {
        if (!newId) {
          return;
        }

        writeCookie(MAIN_SECTION_COOKIE_NAME, newId);
        state.mainSectionId = newId;
    },

    ///////////////
    // CART MUTATIONS

    setCart(state, cart) {
        if (cart && cart.cartId) {
          state.cart = cart;
          writeCookie(CART_ID_COOKIE_NAME, cart.cartId);
        } else {
          state.cart = null; 
          clearCookie(CART_ID_COOKIE_NAME)
        }
    },

    setLoadingCart(state, isLoading) {
      state.isLoadingCart = isLoading;
    },

    ///////////////////////
    // COMPARATOR MUTATIONS

    setcomparator(state, comparatorItemsAsStr) {
      if (!comparatorItemsAsStr) {
        return;
      }
      if (typeof comparatorItemsAsStr === 'string') {
        
        state.comparatorItems = comparatorItemsAsStr.split('|');
      }
    },

    addToComparator(state, itemRef) {

      if (state.comparatorItems.length >= 6) {
        Vue.prototype.$snotify.simple("Nous ne pouvez pas ajouter plus de 6 articles au comparateur");
        return;
      }

      if (!itemRef || state.comparatorItems.includes(itemRef)) {
        return;
      }

      Vue.set(state.comparatorItems, state.comparatorItems.length, itemRef);
      writeCookie(COMPARATOR_ITEMS_COOKIE_NAME, state.comparatorItems.join('|'));
    },

    removeFromComparator(state, itemRef) {

      const index = state.comparatorItems.findIndex(item => item === itemRef);
      if (index !== -1) {
          Vue.delete(state.comparatorItems, index); 
          writeCookie(COMPARATOR_ITEMS_COOKIE_NAME, state.comparatorItems.join('|'));
      }
    }

  },
  actions: {

    ///////////////////////
    // MENU ITEMS ACTIONS

    fetchMenuItems({ commit }) {
      ItemsApi.getMenu().then(
        (menu)=> {
          commit('setMenuItems', menu);
        }
      )
    },

    fetchMainSectionId({commit}) {      
        commit('setMainSectionId', Vue.$cookies.get(MAIN_SECTION_COOKIE_NAME))  
    },

    //////////////////////
    // CART ACTIONS

    fetchCart({commit}) {      
      let newId = Vue.$cookies.get(CART_ID_COOKIE_NAME)

      if (!newId) {
        commit('setCart', null );
        return;
      }

      commit('setLoadingCart', true);
      CartApi.get(newId).then(
        (response)=> {
          if (response && response.status == 200 && response.data) {
            const cart = response.data;
            commit('setCart', cart );
          }
        }
      ).finally(() => {
        commit('setLoadingCart', false);
      });
    }, 

    addToCart({commit}, addToCartRequestList) {
      return new Promise((resolve, reject) => {
            CartApi.add(this.state.cart ? this.state.cart.cartId : null,  addToCartRequestList).then(
              (response)=> {
                if (response && response.status == 200 && response.data) {
                    const cart = response.data;
                    commit('setCart', cart)  
                    resolve(cart);
                } else {
                  reject();
                }
              }
            ) .catch((error) => {
              reject(error);
            });
        });
    },

    setDeliveryModeToCart({commit}, deliveryModeId) {
      return new Promise((resolve, reject) => {
            if (!deliveryModeId) {
              return;
            }
            CartApi.deliveryModeToCart(this.state.cart ? this.state.cart.cartId : null, deliveryModeId).then(
              (response)=> {
                if (response && response.status == 200 && response.data) {
                    const cart = response.data;
                    commit('setCart', cart)  
                    resolve(cart);
                } else {
                  reject();
                }
              }
            ) .catch((error) => {
              reject(error);
            });
        });
    },

    removeFromCart({commit}, variantId) {
      return new Promise((resolve, reject) => {
            if (!variantId) {
              return;
            }
            CartApi.remove(this.state.cart ? this.state.cart.cartId : null, variantId).then(
              (response)=> {
                if (response && response.status == 200) {
                    const cart = response.data;
                    commit('setCart', cart)  
                    resolve(cart);
                } else {
                  reject();
                }
              }
            ) .catch((error) => {
              reject(error);
            });
        });
    },

    ////////////////////////
    // COMPARATOR ACTIONS

    fetchComparatorItems({commit}) {
      commit('setcomparator', Vue.$cookies.get(COMPARATOR_ITEMS_COOKIE_NAME))
    },

    addToComparator({commit}, itemRef) {
      commit('addToComparator', itemRef)  
    },

    removeFromComparator({commit}, itemRef) {
      commit('removeFromComparator', itemRef)  
    },

    fetchGiftCode({ commit }) {
      commit('setGiftCode', Vue.$cookies.get(GIFT_CODE));
    }
  },
});

/*function writeCookie(key, value) {
  var currentDomain = window.location.hostname;
  var cookieDomain = currentDomain.startsWith('www.') ? currentDomain.substring(4) : currentDomain;
  document.cookie = key + "=" + value + ";" + "10000" + ";path=/;"           +    'domain='  + cookieDomain + ';'      ; 
}*/

function writeCookie(key, value) {
  var currentDomain = window.location.hostname;
  var cookieDomain = currentDomain.startsWith('www.') ? currentDomain.substring(4) : currentDomain;
  
  const expiryDays = 365;
  var expiryDate = new Date(Date.now() + expiryDays * 1000 * 60 * 60 * 24);
  
  document.cookie = key + "=" + value + "; " +
                     "expires=" + expiryDate.toUTCString() + "; " +
                     "path=/; " +
                     "domain=" + cookieDomain + "; ";
}


function clearCookie(key) {
  var currentDomain = window.location.hostname;
  document.cookie = key + '=; Max-Age=0; domain=' + currentDomain + '; path=/';
}

export default store


